"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgUserCard = function SvgUserCard(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("path", {
    d: 'M2.5 2.5c.34-.336.849-.503 1.528-.5H20c.665-.006 1.165.161 1.5.5.335.34.502.847.5 1.523V20c0 .667-.166 1.167-.5 1.5-.333.334-.833.5-1.5.5H4.01c-.672 0-1.176-.167-1.51-.5-.334-.332-.5-.832-.5-1.5V4.01c-.006-.67.16-1.173.5-1.51zM12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-3 2c-1.566 0-2.864 1.299-3 3-.008.098 0 1.993 2 2 2 .007 6 0 8 0s2.009-1.898 2-2c-.14-1.695-1.437-3-3-3H9z'
  }));
};

exports.default = SvgUserCard;